import { z } from "zod";

/**
 * Receive Embedded Message - Path Variables
 */
export const ReceiveEmbeddedMessagePathVarsSchema = z.object({
  id: z.string().uuid()
});

/**
 * Receive Embedded Message - Request Body
 *
 * Accepts message content and optional metadata for embed widgets.
 */
export const ReceiveEmbeddedMessageBodySchema = z.object({
  /** Message content text */
  content: z.string().min(1).max(50000),
  /**
   * Anchor the message to one existing chat of the session that `x-session-id`
   * resolves to, instead of that session's most recent live chat.
   *
   * Ignored — silently, and identically to a chat that does not exist — when it
   * does not name a LIVE chat of that same session. These three routes are
   * unauthenticated, so an anchor may never be a way to reach a conversation the
   * caller could not already reach with the session id it already holds.
   */
  chatRoomId: z.string().uuid().optional(),
  /** Embed-specific data (optional) */
  embedData: z.record(z.string(), z.string()).optional()
});

/**
 * Receive Embedded Message - Response
 *
 * Returns the chat with members and message history
 */
export const ReceiveEmbeddedMessageResponseSchema = z.object({
  id: z.string().uuid(),
  messages: z.array(z.any()), // ChatWithMembers type - complex nested structure
  members: z.array(z.any()).optional()
});

export type ReceiveEmbeddedMessagePathVars = z.infer<typeof ReceiveEmbeddedMessagePathVarsSchema>;
export type ReceiveEmbeddedMessageBody = z.infer<typeof ReceiveEmbeddedMessageBodySchema>;
export type ReceiveEmbeddedMessageResponse = z.infer<typeof ReceiveEmbeddedMessageResponseSchema>;
